// ============================================================================
// URL Acortada Types
// ============================================================================

export interface URLAcortada {
  id: number
  codigo: string
  url_destino: string
  titulo?: string
  campana?: string
  canal: string
  grupo: string
  activa: boolean
  habilitar_qr: boolean
  expira_en?: string
  created_at: string
  total_clics: number
  clics_unicos: number
  ultimo_clic?: string
}

export interface URLAcortadaDetalle extends URLAcortada {
  url_corta: string
  url_con_tracking: string
}

export interface URLAcortadaCreateData {
  url_destino: string
  titulo?: string
  campana?: string
  canal?: string
  expira_dias?: number
  grupo?: string
  habilitar_qr?: boolean
}

export interface URLAcortadaUpdateData {
  url_destino?: string
  titulo?: string
  campana?: string
  canal?: string
  activa?: boolean
  expira_en?: string
  grupo?: string
  habilitar_qr?: boolean
}

// ============================================================================
// Clic Types
// ============================================================================

export interface ClicURL {
  id: number
  numero_destinatario?: string
  ip_address?: string
  dispositivo: string
  navegador: string
  pais?: string
  region?: string
  ciudad?: string
  referer?: string
  fecha_clic: string
  origen: string
  latitud?: number | null
  longitud?: number | null
  precision_gps?: number | null
}

export interface ClicReciente {
  id: number
  codigo_url: string
  titulo_url?: string
  numero_destinatario?: string
  ip_address?: string
  dispositivo: string
  navegador: string
  fecha_clic: string
}

export interface ClicsPorDia {
  fecha: string
  clics: number
}

export interface ClicsPorDispositivo {
  dispositivo: string
  clics: number
  porcentaje: number
}

export interface ClicsPorNavegador {
  navegador: string
  clics: number
  porcentaje: number
}

export interface ClicsPorOrigen {
  origen: string
  clics: number
  porcentaje: number
}

export interface ClicsPorNombre {
  nombre: string
  clics: number
}

export interface ClicsPorCanal {
  canal: string
  total: number
}

// ============================================================================
// Analytics Types
// ============================================================================

export interface TopURL {
  id: number
  codigo: string
  titulo?: string
  url_destino: string
  canal: string
  total_clics: number
  activa: boolean
  created_at: string
}

export interface AnalyticsURL {
  url: URLAcortada
  total_clics: number
  clics_hoy: number
  clics_ultimos_7_dias: number
  usuarios_unicos: number
  clics_por_dia: ClicsPorDia[]
  clics_por_dispositivo: ClicsPorDispositivo[]
  clics_por_navegador: ClicsPorNavegador[]
  clics_por_origen: ClicsPorOrigen[]
  clics_por_ciudad: ClicsPorNombre[]
  clics_por_region: ClicsPorNombre[]
  clics_por_pais: ClicsPorNombre[]
  clics_recientes: ClicURL[]
  url_corta: string
  url_con_tracking: string
}

export interface DashboardStats {
  total_urls: number
  urls_activas: number
  total_clics: number
  clics_por_dia: ClicsPorDia[]
  clics_por_canal: ClicsPorCanal[]
  top_urls: TopURL[]
  clics_recientes: ClicReciente[]
}

// ============================================================================
// Filtros y Paginación
// ============================================================================

export interface FiltrosURL {
  canal?: string
  campana?: string
  activa?: boolean | string
  search?: string
  grupo?: string
  page: number
  page_size: number
}

export interface URLsPaginadas {
  count: number
  page: number
  page_size: number
  total_pages: number
  results: URLAcortada[]
}

// ============================================================================
// Response Types
// ============================================================================

export interface URLCreadaResponse {
  success: boolean
  url: URLAcortadaDetalle
  message: string
}

export interface ToggleStatusResponse {
  success: boolean
  activa: boolean
  message: string
}

export interface SuccessResponse {
  success: boolean
  message: string
}

// ============================================================================
// Constantes
// ============================================================================

export const CANALES = [
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
  { value: 'web', label: 'Web' },
  { value: 'social', label: 'Redes Sociales' },
] as const

export type Canal = typeof CANALES[number]['value']

export const GRUPOS = [
  { value: 'tonal', label: 'Tonal' },
  { value: 'personal', label: 'Personal' },
] as const
